import React, { useState } from "react";
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import {
  Grid,
  IconButton,
  Box,
  Typography,
  Menu,
  MenuItem,
} from "@material-ui/core";
import translate from "i18n/translate";
import ApplicationCard from "./ApplicationCard";
import { useStyles } from "./applicationStyles";
import ApplicationIcon from "./ApplicationIcon";

const ApplicationItem = ({ data, onEdit, onDelete, onRestore }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const onMenuClick = (callback) => {
    callback();
    setAnchorEl(null);
  };

  return (
    <Grid item xs={12} md={8}>
      <Grid
        item
        container
        justifyContent="center"
        className={classes.cardContainer}
      >
        <Grid item container xs={12} justifyContent="space-between">
          <Box style={{ display: "flex", alignItems: "center" }} my={2}>
            <ApplicationIcon applicationType={data.platform_id} />
            {
              // TODO: CORRECT data.plaftorm to data.platform when service is ready
            }
            <span className={classes.cardTitle}>{data.application_name}</span>
          </Box>
          <Box style={{ display: "flex", alignItems: "center" }} my={2}>
            <IconButton
              aria-label="more"
              aria-controls={`app-menu-${data?.key}`}
              aria-haspopup="true"
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id={`app-menu-${data?.key}`}
              keepMounted
              PaperProps={{
                style: {
                  maxHeight: 200,
                  width: "15ch",
                },
              }}
              anchorEl={anchorEl}
              onClose={() => {
                setAnchorEl(null);
              }}
              open={Boolean(anchorEl)}
            >
              <MenuItem role="edit" onClick={() => onMenuClick(onEdit)}>
                <EditIcon fontSize="small" />
                <Typography className={classes.marginLeft}>
                  {translate("common.edit")}{" "}
                </Typography>
              </MenuItem>
              <MenuItem role="delete" onClick={() => onMenuClick(onDelete)}>
                <DeleteIcon fontSize="small" className={classes.deleteIcon} />
                <Typography
                  className={`${classes.marginLeft} ${classes.deleteIcon}`}
                >
                  {translate("common.delete")}{" "}
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={12}>
            <ApplicationCard
              name={translate("applications.appKey")}
              appKey={data.key}
              action="common.copy"
            />
          </Grid>
          <Grid item xs={12}>
            <ApplicationCard
              name={translate("applications.publicKey")}
              appKey={data.publishable_key}
              action="common.copy"
            />
          </Grid>
          <Grid item xs={12}>
            <ApplicationCard
              name={translate("applications.secretPass")}
              appKey="*******"
              action="common.reset"
              type="reset"
              actionToExecute={onRestore}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ApplicationItem;
